import React from 'react';

import useStyle from "../useStyles";

import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';

const ReunioesInviteCard = (props) => {

  const {
    user,
    removeFunction,
    addFunction,
    adicionado,
    isVisualizar
  } = props;

  const classes = useStyle();

  const getIniciais = (nome) => nome.substring(0, 2)

return (
  <>
    <div className={classes.cardInvite}>
      <div className={classes.imagemReplaceFotoSmall}>{getIniciais(user.usuarioPerfil ? user.usuarioPerfil.nomeUsuario: user.nome)}</div>
      <p className={classes.nomeCardInvite}>{user.usuarioPerfil ? user.usuarioPerfil.nomeUsuario: user.nome}</p>
      
      <p className={classes.informacoesCardInvite}>
        {(user.usuarioPerfil) ? user.usuarioPerfil?.descricaoTipoPerfil : user?.descricaoTipoPerfil}
        {user.usuarioPerfil?.conselheiroPerfil ? user.usuarioPerfil.conselheiroPerfil?.descricaoTitularidade : user.descricaoTitularidade}
      </p>

      <p className={classes.informacoesCardInvite}>{user.usuarioPerfil ? user.usuarioPerfil.siglaEntidade: user.siglaEntidade}</p>
      {user.convocado && <p className={classes.informacoesCardInviteVerde}>Convocação enviada</p>}
      {!isVisualizar && <>
      {adicionado ?
        <>
          <Button onClick={removeFunction} style={{ marginTop: 10 }}>Remover</Button>
          <div style={{ position: 'absolute', right: 10, top: 10 }}>
            <CloseIcon onClick={removeFunction} style={{ cursor: 'pointer', fontSize: 24, color: '#5e6784', opacity: 0.87 }} />
          </div>
        </> :
        <Button onClick={addFunction} style={{ marginTop: 10 }} variant="outlined">Convidar</Button>} </>}
    </div>
  </>
);
}

export default ReunioesInviteCard;
